import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { userSelector } from "../../store/userSlice";
import AfterLoginHeader from "../../components/header/AfterLoginHeader";
import { getReferalListingsDetail } from "../../api_services/api_calls/referralAgentListingApi";
import { useParams } from "react-router-dom";
import ReferalDetails from "./components/ReferalDetails";
import ReferalObjects from "./components/ReferalObjects";
import ReferalListingObjects from "./components/ReferalListingObjects";

const ViewReferralListing = () => {
    const { userData } = useSelector(userSelector);
    const [loading, setLoading] = useState(false);
    const [referalDetails, setReferalDetails] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        setLoading(true);
        getReferalListingsDetail(id)
            .then((response) => {
                console.log("getReferalListings response", response.data);

                setReferalDetails(response.data);
            })
            .catch((error) => { })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <>
            <AfterLoginHeader userData={userData} />
            <section
                className="section ct_billing_hidtory_pt_top  pt-4 "
                style={{ backgroundColor: "#F9F9F9" }}
            >
                <div className="container mt-5 pt-5">
                    {loading ? (
                        <Skeleton count={5} />
                    ) : (

                        <section className="section3">
                            <div className="flex-container">
                                <ReferalDetails
                                    data={referalDetails?.referalListingData}
                                />
                                <ReferalObjects
                                    data={referalDetails?.referalObjectData}
                                    listingObjects={referalDetails?.listingObjectsData}
                                />

                                <ReferalListingObjects
                                    data={referalDetails?.listingObjectsData}
                                    listingData={referalDetails?.listingData}
                                    referalListingData={referalDetails?.referalListingData}
                                />
                            </div>
                        </section>
                    )}
                </div>
            </section>
        </>
    );
};

export default ViewReferralListing;
